import {BiLoggerFactory} from '@wix/wix-bi-logger-client';
import * as browsingSession from './browsingSession';
import {isWebWorker, setHost} from './lib/env';
import {beaconPublisher, fetchPublisher, imagePublisher} from './lib/publishers';

function getPublisher(options = {}) {
  let publisher;

  if (isWebWorker()) {
    publisher = fetchPublisher;
  } else if (typeof options.useBeacon === 'undefined' || options.useBeacon) {
    publisher = beaconPublisher;
  } else {
    publisher = imagePublisher;
  }

  return publisher(options);
}

const factory = options => new BiLoggerFactory().addPublisher(getPublisher(options));

const logger = {
  factory: (options = {}) => {
    const trackSession = options.trackSession || typeof options.trackSession === 'undefined';

    if (trackSession) {
      browsingSession.track(factory);
    }

    return factory(options);
  },
  setHost
};

export default logger;



// WEBPACK FOOTER //
// ./logger.js